// S6 (K100 PRE-LIVE; WAJIB_PINTU 23 Sep 2026) — pemilih lot/roll kain per item Pengeluaran Bahan.
//
// Lot direkam saat penerimaan barang (GRN, Receiving.jsx); di sini orang gudang menyebut roll
// mana yang dipotong untuk WO ini, supaya repeat order bisa mencari lot yang sama dan reject
// karena lot jelek bisa ditelusuri. Lapis 1 OPSIONAL: kosong = sah. Bila diisi, jumlah qty lot
// WAJIB sama dengan qty item — backend menolaknya dengan LOT_QTY_SUM_MISMATCH, layar memeriksa
// lebih dulu supaya orangnya tahu sebelum menekan tombol.
import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/inventoryApi";
import { ambilSemua } from "../../lib/ambilSemua";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Plus, X } from "lucide-react";

export function selisihLot(lots, qty) {
  const isi = (lots || []).filter(l => l.fabric_lot_id || l.qty);
  if (!isi.length) return null;
  if (isi.some(l => !l.fabric_lot_id)) return "Pilih lot untuk tiap baris lot.";
  if (new Set(isi.map(l => l.fabric_lot_id)).size !== isi.length) return "Ada lot yang dipilih dua kali.";
  if (isi.some(l => !(Number(l.qty) > 0))) return "Qty tiap lot harus lebih dari 0.";
  const total = isi.reduce((s, l) => s + Number(l.qty), 0);
  if (Math.abs(total - Number(qty)) > 1e-6) return `Jumlah qty lot (${+total.toFixed(3)}) harus sama dengan qty item (${qty}).`;
  return null;
}

export default function PemilihLotKain({ materialId, storeId, qty, value, onChange }) {
  const [lot, setLot] = useState([]);
  const [muat, setMuat] = useState(false);
  const [galat, setGalat] = useState("");

  useEffect(() => {
    setLot([]); setGalat("");
    if (!materialId || !storeId) return;
    setMuat(true);
    ambilSemua((p) => api.get("/inventory/fabric-lots", { params: p }), { material_id: materialId, store_id: storeId })
      .then(setLot)
      .catch(e => setGalat(apiErrorMessage(e, "Daftar lot gagal dimuat.")))
      .finally(() => setMuat(false));
  }, [materialId, storeId]);

  if (!materialId || !storeId) return null;
  if (muat) return <p className="text-xs text-muted-foreground">Memuat lot kain…</p>;
  if (galat) return <p className="text-xs text-danger-soft-foreground">{galat}</p>;
  if (!lot.length) {
    return <p className="text-xs text-muted-foreground" data-testid="mi-lot-kosong">Bahan ini belum punya lot tercatat di gudang WO ini — lot direkam saat penerimaan barang.</p>;
  }

  const baris = value || [];
  const ubah = (i, patch) => onChange(baris.map((b, j) => (j === i ? { ...b, ...patch } : b)));
  const pesan = selisihLot(baris, qty);

  return (
    <div className="rounded border border-dashed p-2 space-y-1" data-testid="mi-lot-pemilih">
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground">Lot / roll kain (opsional — isi bila tahu roll mana yang dipotong)</span>
        <Button type="button" variant="ghost" size="sm" onClick={() => onChange([...baris, { fabric_lot_id: "", qty: baris.length ? "" : qty }])}
                data-testid="mi-lot-tambah">
          <Plus className="h-3 w-3 mr-1" /> Lot
        </Button>
      </div>
      {baris.map((b, i) => (
        <div key={i} className="flex gap-2 items-center">
          <select value={b.fabric_lot_id} onChange={e => ubah(i, { fabric_lot_id: e.target.value })}
                  className="flex-1 h-8 rounded border px-2 text-xs" data-testid={`mi-lot-select-${i}`}>
            <option value="">— Pilih lot —</option>
            {lot.map(l => (
              <option key={l.id} value={l.id}>
                {l.lot_code} · terima {l.qty_received} · sisa {l.qty_sisa}{l.qty_tertahan ? ` (tertahan ${l.qty_tertahan})` : ""}
              </option>
            ))}
          </select>
          <Input type="number" step="0.001" className="w-24 h-8 text-xs" value={b.qty}
                 onChange={e => ubah(i, { qty: e.target.value })} data-testid={`mi-lot-qty-${i}`} />
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(baris.filter((_, j) => j !== i))}>
            <X className="h-3 w-3" />
          </Button>
        </div>
      ))}
      {pesan && <p className="text-xs text-danger-soft-foreground" data-testid="mi-lot-pesan">{pesan}</p>}
    </div>
  );
}
